module.exports = __webpack_public_path__ + "fonts/RobotoSlab-Bold.5bc3a85.woff2";